import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle, Calendar, MapPin } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function GuestSuccessPage() {
  const [searchParams] = useSearchParams();
  const regId = searchParams.get('reg_id');
  const eventId = searchParams.get('event_id');
  const [status, setStatus] = useState('loading');
  const [registration, setRegistration] = useState(null);
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const [regRes, eventRes] = await Promise.all([
          fetch(`${API_URL}/api/events/public/guest-verify/${regId}`),
          fetch(`${API_URL}/api/events/public/${eventId}`)
        ]);
        
        const regData = await regRes.json();
        const eventData = await eventRes.json();
        
        setRegistration(regData.registration);
        setEvent(eventData);
        setStatus(regData.status === 'paid' ? 'success' : 'pending');
      } catch {
        setStatus('error');
      }
    };
    
    if (regId && eventId) verify();
    else setStatus('error');
  }, [regId, eventId]);

  return (
    <div style={{ 
      minHeight: '100vh', background: '#f5f5f5', 
      display: 'flex', alignItems: 'center', justifyContent: 'center', 
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", padding: 16 
    }}>
      <div style={{ background: '#fff', maxWidth: 500, width: '100%', textAlign: 'center' }}>
        {/* Header */}
        <div style={{ background: '#d5001c', padding: '24px', color: '#fff' }}>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase' }}>
            S.H.R.T.
          </h1>
        </div>

        <div style={{ padding: 32 }}>
          {status === 'loading' && (
            <div>
              <Loader2 size={48} style={{ animation: 'spin 1s linear infinite', color: '#d5001c', margin: '0 auto 16px' }} />
              <p style={{ fontSize: 16, color: '#666' }}>Zahlung wird überprüft...</p>
            </div>
          )}

          {status === 'success' && (
            <div>
              <CheckCircle size={64} style={{ color: '#22c55e', margin: '0 auto 16px' }} />
              <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>Zahlung bestätigt!</h2>
              <p style={{ color: '#666', marginBottom: 24 }}>
                Vielen Dank, {registration?.member_name}. Ihre Anmeldung ist bestätigt.
              </p>
              {event && (
                <div style={{ background: '#f8f8f8', padding: 20, textAlign: 'left', marginBottom: 16 }}>
                  <h3 style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 700 }}>{event.title}</h3>
                  <p style={{ margin: '4px 0', fontSize: 14, color: '#555', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Calendar size={14} /> {event.date && new Date(event.date).toLocaleDateString('de-CH', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                  </p>
                  {event.location && (
                    <p style={{ margin: '4px 0', fontSize: 14, color: '#555', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <MapPin size={14} /> {event.location}
                    </p>
                  )}
                </div>
              )}
              <p style={{ fontSize: 13, color: '#999' }}>
                Eine Bestätigungs-E-Mail wurde an {registration?.member_email} gesendet.
              </p>
            </div>
          )}

          {status === 'pending' && (
            <div>
              <Loader2 size={48} style={{ color: '#f59e0b', margin: '0 auto 16px' }} />
              <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>Zahlung wird verarbeitet</h2>
              <p style={{ color: '#666' }}>
                Ihre Zahlung wird noch verarbeitet. Sie erhalten eine E-Mail sobald die Zahlung bestätigt ist.
              </p>
            </div>
          )}

          {status === 'error' && (
            <div>
              <XCircle size={64} style={{ color: '#ef4444', margin: '0 auto 16px' }} />
              <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>Fehler</h2>
              <p style={{ color: '#666' }}>
                Die Anmeldung konnte nicht verifiziert werden. Bitte kontaktieren Sie uns unter info@shrt.ch.
              </p>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
